import { useEffect, useState } from 'react';
import styles from './MiniTooltip.module.css';

const MiniTooltip = ({ content, childern }) => {
  const [showTooltip, setShowTooltip] = useState(false);

  const handleMouseEnter = () => {
    setShowTooltip(true);
  }

  const handleMouseLeave = () => {
    setShowTooltip(false);
  }

  return (
    <div
      onMouseEnter={handleMouseEnter}
      onMouseLeave={handleMouseLeave}
      className={styles['container']}
    >
      ⓘ
      { showTooltip && 
        <div className={styles['tooltip']}>
          <p className={styles['desc']}>{content}</p>
        </div>
      }
      
    </div>
  )
}

export default MiniTooltip;